
































































































































































import {Vue, Component} from 'vue-property-decorator';
import {GetServicesMe, OriginalAddress} from 'supporter';
import {toI18n} from '@/utils/commonUtils';
import {ncpPopup} from '@/utils/ncp';
type PatternName = 'repemailId' | 'repemailDomain' | 'repphoneNo' | 'priphoneNo';

interface ServicesData extends GetServicesMe {
  repname: string;
  repphoneNo: string;
  repemailId: string;
  repemailDomain: string;
  priphoneNo: string;
}

@Component
export default class ServiceInfo extends Vue {
  private isShowGuideLayer = false;
  private servicesData: ServicesData = {
    address: {
      zipCode: '',
      address: '',
      jibunDetail: '',
      detailAddress: '',
      jibun: ''
    },
    business: {
      condition: '',
      registrationNo: '',
      type: '',
      onlineMarketingDeclarationNo: ''
    },
    permittedIpAddress: '',
    faxNo: '',
    countryCode: '',
    serviceStatus: '',
    privacyManager: {
      name: '',
      position: '',
      team: '',
      email: '',
      phoneNo: ''
    },
    companyName: '',
    serviceNo: -1,
    serviceName: '',
    representative: {
      name: '',
      email: '',
      phoneNo: ''
    },
    repname: '',
    repphoneNo: '',
    repemailId: '',
    repemailDomain: '',
    priphoneNo: ''
  };

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  private regObj = {
    // repname: new RegExp('[a-zA-Z0-9ㄱ-힣]|\\s{0,1}', 'g'),
    repphoneNo: new RegExp('[0-9-]+', 'g'),
    faxNo: new RegExp('[0-9-]+', 'g'),
    repemailId: new RegExp('[a-z0-9+.\\-_]', 'g'),
    repemailDomain: new RegExp('[a-z0-9\\-+.]', 'g'),
    priphoneNo: new RegExp('[0-9-]+', 'g')
  };

  private errObj: {[propName: string]: any} = {
    repname: false,
    repphoneNo: false,
    faxNo: false,
    repemailId: false,
    repemailDomain: false,
    priphoneNo: false
  };

  private stringHandle(value: string, name: PatternName) {
    const validArr = value.match(this.regObj[name]);
    if (!validArr || validArr.join('').length < value.length) {
      this.errObj[name] = true;
      const result = this.servicesData[name].match(this.regObj[name]);
      if (result && result.length) {
        this.servicesData[name] = result.join('');
      } else {
        this.servicesData[name] = '';
      }
    }
  }

  private inputCheck(event: any) {
    const target: {name: string; value: string} = event.target;
    const {name, value} = target;
    this.stringHandle(value, name as PatternName);
  }

  private blurCheck(event: any) {
    const target: {name: string} = event.target;
    const {name} = target;
    this.errObj[name as PatternName] = false;
  }

  private checkIpAddressInput(ipInputString: string) {
    const ipInputStringLengthCheck = ipInputString.replace(/(\r\n|\n|\r)/g, '  ');
    if (ipInputStringLengthCheck.length > 1000) {
      alert(this.toI18n('SERVICE_INFO_ALERT_1')); // 'ip대역 전체 길이는 1000자를 넘을 수 없습니다'
      return false;
    }

    const ipInput = ipInputString.split('\n').filter(ip => ip.length !== 0);
    const rangeIpPattern = /^[^-]*-[^-]*$/;
    const ipPattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;

    let i;
    for (i = 0; i < ipInput.length; i++) {
      // check for range input
      if (ipInput[i].match(rangeIpPattern)) {
        const range = ipInput[i].split('-');
        const start = range[0].substr(range[0].lastIndexOf('.') + 1, range[0].length + 1);
        const end = range[1].substr(range[1].lastIndexOf('.') + 1, range[1].length + 1);
        range[1] = range[0].substring(0, range[0].lastIndexOf('.') + 1) + end;

        if (!range[0].match(ipPattern) || !range[1].match(ipPattern) || start >= end) {
          alert(this.toI18n('SERVICE_INFO_ALERT_2')); // '정확한 ip 대역폭 주소를 입력해 주세요.'
          return false;
        }
      } else if (!ipInput[i].match(ipPattern)) {
        alert(this.toI18n('SERVICE_INFO_ALERT_3')); // '정확한 ip 주소를 입력해 주세요.'
        return false;
      }
    }
    return true;
  }

  private isFormPassed() {
    if (!this.servicesData.companyName) {
      alert(this.toI18n('SERVICE_INFO_ALERT_INSERT_COMPANY_NAME')); // '회사명을 입력하세요.'
      return false;
    }
    if (!this.servicesData.business.registrationNo) {
      alert(this.toI18n('SERVICE_INFO_ALERT_INSERT_REGISTRATION_NO')); // '사업자 등록번호를 입력해주세요.'
      return false;
    }
    if (!this.servicesData.repname) {
      alert(this.toI18n('SERVICE_INFO_ALERT_4')); // '대표자명을 입력하세요.'
      return false;
    }
    if (!this.servicesData.business.type) {
      alert(this.toI18n('SERVICE_INFO_ALERT_5')); // '업종을 입력하세요.'
      return false;
    }
    if (!this.servicesData.business.condition) {
      alert(this.toI18n('SERVICE_INFO_ALERT_6')); // '업태을 입력하세요.'
      return false;
    }
    if (!this.servicesData.repphoneNo) {
      alert(this.toI18n('SERVICE_INFO_ALERT_7')); // '대표전화번호를 입력하세요.'
      return false;
    }
    if (!this.servicesData.repemailId) {
      alert(this.toI18n('SERVICE_INFO_ALERT_8')); // '대표 e메일을 입력하세요.'
      return false;
    }
    if (!this.servicesData.repemailDomain) {
      alert(this.toI18n('SERVICE_INFO_ALERT_8')); // '대표 e메일을 입력하세요.'
      return false;
    }
    if (!this.servicesData.address.zipCode) {
      alert(this.toI18n('SERVICE_INFO_ALERT_10')); // '사업장 주소를 입력하세요.'
      return false;
    }
    if (!this.servicesData.address.address || !this.servicesData.address.jibun) {
      alert(this.toI18n('SERVICE_INFO_ALERT_10')); // '사업장 주소를 입력하세요.'
      return false;
    }
    if (!this.checkIpAddressInput(this.servicesData.permittedIpAddress)) {
      // 접속 IP 설정 체크
      return false;
    }

    return confirm(this.toI18n('SERVICE_INFO_ALERT_12')); // '변경 된 내용을 저장하시겠습니까?'
  }

  private putService() {
    if (!this.isFormPassed()) {
      return;
    }
    const data = {
      representative: {
        email: this.servicesData.repemailId + '@' + this.servicesData.repemailDomain,
        name: this.servicesData.repname,
        phoneNo: this.servicesData.repphoneNo
      },
      privacyManager: {...this.servicesData.privacyManager, phoneNo: this.servicesData.priphoneNo},
      address: {...this.servicesData.address},
      business: {...this.servicesData.business},
      permittedIpAddress: this.servicesData.permittedIpAddress,
      faxNo: this.servicesData.faxNo,
      companyName: this.servicesData.companyName,
    };

    this.$api
      .putServicesByServiceNo({
        params: {serviceNo: this.servicesData.serviceNo},
        data
      } as any)
      .then(() => {
        alert(this.toI18n('SERVICE_INFO_ALERT_13')); // '변경사항이 저장 되었습니다.'
        this.getServcies();
      });
  }

  private getServcies() {
    this.$api.getServicesMe().then((response: any) => {
      const data = response.data as GetServicesMe;
      Object.assign(this.servicesData, {...data});
      const [repemailId, repemailDomain] = data.representative.email.split('@');
      const {
        representative: {name: repname, phoneNo: repphoneNo},
        privacyManager: {phoneNo: priphoneNo}
      } = data;
      Object.assign(this.servicesData, {
        repemailId,
        repemailDomain,
        repname,
        repphoneNo,
        priphoneNo
      });
    });
  }

  private created() {
    this.getServcies();
  }
  callback(address: OriginalAddress) {
    (window as any).addressCallback = undefined;
    this.servicesData.address.zipCode = address.zipCode;
    this.servicesData.address.address = address.roadAddress;
    this.servicesData.address.detailAddress = address.roadAddressExtra;
    this.servicesData.address.jibun = address.jibunAddress;
    this.servicesData.address.jibunDetail = '';
  }
  private openAddress() {
    (window as any).addressCallback = this.callback;
    ncpPopup('/address/search/popup?dataCallback=addressCallback', this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_POSTAL_CODE'), 550, 880);
  }
}
